const colorList = [
    "#5186ff",
    "#599d34",
    "#26b1b1",
    "#a452e0",
    "#e840c1",
    "#f47487",
    "#ffe558",
    "#fd9f3e",
    "#92d823",
    "#3edaff",
];

export default colorList;
